// @flow
import { List } from 'immutable';
import {
  LOAD_RESOURCES_DETAILS,
  LOAD_RESOURCES_DETAILS_SUCCESS,
  LOAD_RESOURCES_DETAILS_FAIL,
  RESOURCES_DETAILS,
} from './../types/resource';
import type { ResourceDetail } from './../types/resource';

export type ResourceAction = {
  type: string,
  error?: string,
  axiosInstance?: Object,
  resourcesDetails?: List<ResourceDetail>,
  resourceId?: Number,
};

export const loadResourcesDetails = (axiosInstance: Object, id: Number): ResourceAction => ({
  type: LOAD_RESOURCES_DETAILS,
  id,
  axiosInstance,
});

export const loadResourcesDetailsSuccess = (resourcesDetails: List<ResourceDetail>): ResourceAction => ({
  type: LOAD_RESOURCES_DETAILS_SUCCESS,
  [RESOURCES_DETAILS]: resourcesDetails
});

export const loadResourcesDetailsFail = (error: string): ResourceAction => ({
  type: LOAD_RESOURCES_DETAILS_FAIL,
  error
});


// WEBPACK FOOTER //
// ./src/actions/resource.jsx